module.exports = "precision mediump float;\r\n\r\nattribute vec4 aVertexPosition;\r\n\r\nuniform mat4 uViewProjectionInverse;\r\nuniform vec4 cameraPosition;\r\n\r\nvarying vec4 screenCoords;\r\nvarying vec4 rayVector;\r\n\r\nvoid main() {\r\n    rayVector = uViewProjectionInverse * aVertexPosition;\r\n    rayVector = vec4(rayVector.xyz / rayVector.w, 1.0);\r\n    rayVector = rayVector - cameraPosition;\r\n\r\n    screenCoords = aVertexPosition;\r\n    gl_Position = aVertexPosition;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/webgl/vert.glsl
// module id = 11
// module chunks = 0